import { dashboardBirthdayComponent } from './dashboard.birthday.component';
import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule';
import { dashboard } from './dashboard.component';
import { dashboardState, newsItemBasicState } from './dashboard.states';
import { dashboardOpenshiftsComponent } from './dashboard.openshifts.component';
import { dashboardSkillsComponent } from './dashboard.skills.component';
import { dashboardNotesComponent } from './notes/dashboardNotes.component';
import { dashboardAvailableEmployeesComponent } from './availableEmployees/dashboardAvailableEmployees.component';
import { dashboardTimesheetsSummaryComponent } from './timesheetsSummary/dashboardTimesheetsSummary.component';
import { dashboardTasksComponent } from './tasks/dashboardTasks.component';
import { EmployeeAvailabilityService } from '../../services/employeeAvailability.service';
import { NewsService } from '../../services/news.service';
import { dashboardNewsComponent } from './news/dashboardNews.component';
import { newsItemBasicComponent } from './news/news.item.basic.component';

const dashboardAppModule: aboTheme.INgModule = {
  components: {
    dashboard,
    dashboardBirthdayComponent,
    dashboardOpenshiftsComponent,
    dashboardSkillsComponent,
    dashboardNotesComponent,
    dashboardAvailableEmployeesComponent,
    dashboardTimesheetsSummaryComponent,
    dashboardTasksComponent,
    dashboardNewsComponent,
    newsItemBasicComponent
  },
  states: [
    dashboardState,
    newsItemBasicState
  ],
  services: { EmployeeAvailabilityService, NewsService }
};

loadNg1Module(ngmodule, dashboardAppModule);



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/index.ts